import { Identify, createInstance } from '@amplitude/marketing-analytics-browser'

import type { Customer } from '@brighterly/lib-core-types/customer/interfaces'

import { isObject, pick } from '@shared/lib/object'
import { getQueryParamsObject } from '@shared/lib/query'

import { getUserAgentInfo } from './user-agent'

export const amplitude = createInstance()

export const trackEvent = (eventName: string, eventProps?: Record<string, any>, callback = (): void => {}): void => {

  const props = pick({
    app: 'hiring-app',
    ...(eventProps || {}),
  })

  const hasProps = Object.keys(props).length > 0

  const deviceProps = getUserAgentInfo()
  const isCallback = (typeof callback === 'function')
  if (!hasProps) {
    amplitude
      .track(eventName, { ...deviceProps }).promise
      .finally(() => {
        if (isCallback) {
          callback()
        }
      })
  } else {
    amplitude
      .track(eventName, { ...deviceProps, ...props }).promise
      .finally(() => {
        if (isCallback) {
          callback()
        }
      })
  }
}

export const setAmplitudeUserProperty = (name: string, value: string, once: boolean = false): void => {
  const identify = new Identify()
  identify[once ? 'setOnce' : 'set'](name, value)
  amplitude.identify(identify)
}

export const setUserPropertiesFromQuery = (callback = (): void => {
}): void => {
  const paramsObj = getQueryParamsObject() as string[]
  const paramsKeys = Object.keys(paramsObj)
  if (paramsKeys.length > 0) {
    const identifySetOnceObj = new Identify()

    paramsKeys.forEach(param => {
      const query = paramsObj[param as keyof typeof paramsObj] as any
      identifySetOnceObj.setOnce(`initial_${param}`, query)
      identifySetOnceObj.set(param, query)
    })
    amplitude
      .identify(identifySetOnceObj)
      .promise.finally(() => {
        callback?.()
      })
  }
}

export const setMarketingUserProperties = (data: Customer['marketing_data']): void => {
  if (!isObject(data)) {
    console.warn('Invalid data for booking user properties.')
  } else {
    const identifySetOnceObj = new Identify()
    Object.keys(data).map(key => {
      // @ts-expect-error any type data key
      const value = data[key]
      if (value !== null) {
        identifySetOnceObj.set(key, value)
      }
      return key
    })
    amplitude.identify(identifySetOnceObj)
  }
}

export const setBookingUserProperties = (data: Customer['marketing_data']): void => {
  if (!isObject(data)) {
    console.warn('Invalid data for booking user properties.')
  } else {
    const identifySetOnceObj = new Identify()
    Object.keys(data).map(key => {
      // @ts-expect-error any type data key
      const value = data[key]
      if (value !== null) {
        identifySetOnceObj.setOnce(`booking_${key}`, value)
      }
      return key
    })
    amplitude.identify(identifySetOnceObj)
  }
}
